import { render, staticRenderFns } from "./FolderEmailItemHeader.vue?vue&type=template&id=0fefb605&scoped=true"
import script from "./FolderEmailItemHeader.vue?vue&type=script&lang=js"
export * from "./FolderEmailItemHeader.vue?vue&type=script&lang=js"
import style0 from "./FolderEmailItemHeader.vue?vue&type=style&index=0&id=0fefb605&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fefb605",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
